@if(media) {
  @if(media.type === 'image'){
    <div class="justify-items-center">
      <img
        [src]="media.url"
        [alt]="'Placement Media'"
        class="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain"
      />
    </div>
  } @else if (media.type === 'video') {
    <div class="justify-items-center">
      <video
        [src]="media.url"
        controls
        controlsList="nodownload"
        class="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain"
      >
        {{ 'media.browserUnsupportedVideo' | transloco }}.
      </video>
    </div>
  } @else {
    <div>
      <p>{{ 'media.unsupportedMedia' | transloco }}.</p>
    </div>
  }
}